import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=fe1ed2c0&"
import script from "./NotFoundView.vue?vue&type=script&lang=js&"
export * from "./NotFoundView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports